/**
 * FilterSelect Component
 *
 * Single-select dropdown filter.
 */

import React from 'react';
import { ChevronDown } from 'lucide-react';
import { FilterSelectProps } from './types';

export function FilterSelect({
  value,
  onChange,
  options,
  placeholder = 'Select...',
  disabled = false,
  className = '',
}: FilterSelectProps) {
  return (
    <div className={`relative ${className}`}>
      <select
        value={value || ''}
        onChange={(e) => onChange(e.target.value)}
        disabled={disabled}
        className={`
          appearance-none
          block w-full pl-3 pr-10 py-2
          text-sm
          border border-gray-300 rounded-lg
          bg-white
          focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-purple-500
          disabled:bg-gray-100 disabled:text-gray-500 disabled:cursor-not-allowed
          transition-colors
          ${!value ? 'text-gray-500' : 'text-gray-900'}
        `}
      >
        <option value="">{placeholder}</option>
        {options.map((option) => (
          <option key={option.value} value={option.value} disabled={option.disabled}>
            {option.label}
          </option>
        ))}
      </select>
      <div className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
        <ChevronDown className="h-4 w-4 text-gray-400" />
      </div>
    </div>
  );
}

export default FilterSelect;
